import { useEffect, useState } from "react";

import Toggle from "react-toggle";
import "react-toggle/style.css";
import useInView from "react-cool-inview";
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";

const CompareTest = (props) => {

  const [ready, setReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  }, [])


  const { observe, unobserve, inView } = useInView({
    onEnter: ({ unobserve }) => unobserve(),
  });
  const [insurance, setInsurance] = useState(true);
  const setInsuranceVal = () => {
    insurance == true ? setInsurance(false) : setInsurance(true);
  };
  return (
    <>
      {props.home ? (
        ""
      ) : (
        <div className="section-gap healthcare-main" ref={observe}>
          {inView && (
            <div className="container">
              <div className="section-gap test">
                <div className="section-title text-start">
                  <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "45px" }}>
                    <h2>Next Medical vs. Others</h2>
                  </ReactPlaceholder>

                  {/* <div className="text-center toogle-main">
                  <span>Without insurance</span>
                  <Toggle
                    className="toggle-compare mt-0"
                    defaultChecked={insurance}
                    onChange={(e) => setInsuranceVal()}
                  />
                  <span>With insurance</span>
                </div> */}
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <table className="table tb-compare-test compare-text-table">
                      <colgroup>
                        <col />
                        <col />
                        <col className="outlined" />
                        <col span="3" />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col"></th>
                          <th scope="col" className="border-popular-top ">
                            {" "}
                            <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "100px", marginTop: "20px" }}>
                              <img
                                src="/images/logo.webp"
                                className="logo-img "
                              />{" "}
                            </ReactPlaceholder>
                          </th>
                          <th scope="col" className="competitors-logo">
                            <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "100px", marginTop: "20px" }}>
                              <img src="/clinic.webp" className="logo-icon" />{" "}
                              <p>Clinic</p>
                            </ReactPlaceholder>
                          </th>
                          <th scope="col" className="competitors-logo">
                            <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "100px", marginTop: "20px" }}>
                              <img src="/images/kit.webp" className="logo-icon" />
                              <p>Kit</p>
                            </ReactPlaceholder>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {/* firstRow */}
                        <tr>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.firstRow.title}</ReactPlaceholder></td>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}> {props.data.firstRow.nextmed}</ReactPlaceholder></td>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.firstRow.clinic}</ReactPlaceholder></td>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.firstRow.kit}</ReactPlaceholder></td>
                        </tr>
                        {/* second */}
                        <tr>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.secondRow.title}</ReactPlaceholder></td>
                          <td>
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              {props.type === "std" && (
                                <img src={props.data.secondRow.nextmed} />
                              )}

                              {props.type === "covid" && (
                                <img src={props.data.secondRow.nextmed} />
                              )}

                              {props.type === "allergies" && (
                                <img src={props.data.secondRow.nextmed} />
                              )}
                            </ReactPlaceholder>
                          </td>
                          <td>
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              {props.type === "std" && (
                                <img src={props.data.secondRow.clinic} />
                              )}
                              {props.type === "covid" && (
                                <i className="fa fa-times" aria-hidden="true"></i>
                              )}
                              {props.type === "allergies" && (
                                <img src={props.data.secondRow.clinic} />
                              )}
                            </ReactPlaceholder>
                          </td>
                          <td>
                            {props.type === "std" && (
                              <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                                <i
                                  className={props.data.secondRow.kit}
                                  aria-hidden="true"
                                ></i>
                              </ReactPlaceholder>
                            )}
                            {props.type === "covid" && (
                              <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                                <i
                                  className={props.data.secondRow.kit}
                                  aria-hidden="true"
                                ></i>
                              </ReactPlaceholder>
                            )}
                            {props.type === "allergies" && (
                              <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                                <i
                                  className={props.data.secondRow.kit}
                                  aria-hidden="true"
                                ></i>
                              </ReactPlaceholder>
                            )}
                          </td>
                        </tr>
                        {/* third */}
                        <tr>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.thirdRow.title}</ReactPlaceholder></td>
                          <td>
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              {props.type === "std" && (
                                <img src={"/tick.webp"} />
                              )}
                              {props.type === "covid" && (
                                <i
                                  className={props.data.thirdRow.nextmed}
                                  aria-hidden="true"
                                ></i>
                              )}
                              {props.type === "allergies" && (
                                <i
                                  className={props.data.thirdRow.nextmed}
                                  aria-hidden="true"
                                ></i>
                              )}
                            </ReactPlaceholder>
                          </td>
                          <td>
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              {" "}
                              {props.type === "std" && <img src="/tick.webp" />}
                              {props.type === "covid" && <img src="/tick.webp" />}
                              {props.type === "allergies" && (
                                <img src="/tick.webp" />
                              )}
                            </ReactPlaceholder>
                          </td>
                          <td>
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              {props.type === "std" && (
                                <i
                                  className={props.data.thirdRow.kit}
                                  aria-hidden="true"
                                ></i>
                              )}
                              {props.type === "covid" && <img src="/tick.webp" />}
                              {props.type === "allergies" && (
                                <i className="fa fa-times" aria-hidden="true"></i>
                              )}
                            </ReactPlaceholder>
                          </td>
                        </tr>
                        <tr>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}> {props.data.fourthRow.title}</ReactPlaceholder></td>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.fourthRow.nextmed}</ReactPlaceholder></td>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.fourthRow.clinic}</ReactPlaceholder></td>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}> {props.data.fourthRow.kit}</ReactPlaceholder></td>
                        </tr>
                        <tr>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.fifthRow.title}</ReactPlaceholder></td>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.fifthRow.nextmed}</ReactPlaceholder></td>
                          <td> <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>{props.data.fifthRow.clinic}</ReactPlaceholder></td>
                          <td><ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}> {props.data.fifthRow.kit}</ReactPlaceholder></td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr className=" ">
                          <td></td>
                          <td className="border-popular-bottom">
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              {props.variant == "insurance" ? <strong className="heighlighted-price">
                                $59
                              </strong> :
                                <strong className="heighlighted-price">
                                  {insurance ? props.data.total.nextmed : "$149 +"}
                                </strong>}
                            </ReactPlaceholder>
                          </td>
                          <td>
                            {" "}
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              <strong className="copay-text">
                                {props.data.total.clinic}
                              </strong>
                            </ReactPlaceholder>
                          </td>
                          <td>
                            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: " 20px" }}>
                              <strong>{props.data.total.kit}</strong>
                            </ReactPlaceholder>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div className="col-md-12">
                    <div className="view-tests-btn text-center">
                      <ReactPlaceholder showLoadingAnimation ready={ready} type="rect" style={{ height: "40px", width: "300px", margin: "auto" }}>
                        <a href="#view-tests" className="btn btn-lg-secondary">
                          Select Test
                        </a>
                      </ReactPlaceholder>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}{" "}
        </div>
      )}
    </>
  );
};
export default CompareTest;
